/**
 * PosterRatingBar — one-tap 5-star rating (IIG Phase 5 §4.10, built 2026-07-14).
 * The ONLY user-visible ask in the whole IIG learning loop: a single optional
 * tap. Never a modal, never required, errors swallowed — a rating failure must
 * never disturb the flow that hosts the bar. Feeds poster_feedback +
 * iig_evidence('rated') via the printables worker.
 */
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import usePrintables from '../../services/usePrintables';

export default function PosterRatingBar({ posterId, source, onDone }) {
  const { t } = useTranslation('home');
  const { submitPosterFeedback } = usePrintables();
  const [hover, setHover] = useState(0);
  const [picked, setPicked] = useState(0);
  const [done, setDone] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current); }, []);

  const rate = (rating) => {
    if (picked) return;
    setPicked(rating);
    submitPosterFeedback(posterId, { rating, source }).catch((e) =>
      console.warn('[PosterRatingBar] rating not saved:', e?.message));
    timerRef.current = setTimeout(() => { setDone(true); onDone?.(); }, 3000);
  };

  if (done) return null;

  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 10,
        fontFamily: 'inherit', fontSize: 13,
        color: 'rgba(27,37,80,0.712)', background: 'transparent',
        padding: '6px 0', minHeight: 32,
      }}
    >
      {picked ? (
        <span>{t('rating.thanks')}</span>
      ) : (
        <>
          <span>{t('rating.question')}</span>
          <span style={{ display: 'inline-flex', gap: 2 }}>
            {[1, 2, 3, 4, 5].map((n) => (
              <button
                key={n}
                type="button"
                aria-label={t('rating.starAria', { count: n })}
                onClick={() => rate(n)}
                onMouseEnter={() => setHover(n)}
                onMouseLeave={() => setHover(0)}
                style={{
                  width: 28, height: 28, padding: 0,
                  background: 'transparent', border: 'none', cursor: 'pointer',
                  fontSize: 19, lineHeight: '28px',
                  color: n <= (hover || picked) ? 'rgba(127,75,246,0.95)' : 'rgba(27,37,80,0.285)',
                  transition: 'color 120ms ease',
                }}
              >
                ★
              </button>
            ))}
          </span>
        </>
      )}
    </div>
  );
}
